import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/database';
import _ from 'lodash'
import format from 'date-fns/format'
import addDays from 'date-fns/add_days';
import addMonths from 'date-fns/add_months';
import axios from 'axios';
import {getCompany,getUserAll} from './cacheService'
import { ensureReportAuth } from './core/reportAuth'
export default {
  namespaced: true,
  state: {
    highPerformingManagers: [],
    company:{},
    replyRate:{
        highPerformers:0,
        orgAverage:0,
        compare:0
    },
    debi:{
        highPerformers:0,
        orgAverage:0,
        compare:0
    },
    loading: true,
    autosendgem: false,
  },
  mutations: {
    sethighPerformingManagers(state:any, data:any){
      state.highPerformingManagers = data
    },
    setCompany(state:any, data:any){
      state.company = data
    },
    setReplyRate(state:any, data:any){
      state.replyRate = data
    },
    setDebi(state:any, data:any){
      state.debi = data
    },
    setUser(state:any, data:any){
      state.user = data
    },
    setLoading(state:any, data:any){
      state.loading = data
    },
    setAutosendgem(state:any, data:any){
      state.autosendgem = data
    }
  },
  actions: {
    async login({commit,state}:any, obj:any){
        commit('setLoading',true)
        state.loading = true
        console.log('No user is signed in.')
        await ensureReportAuth()
    },

    async getData({commit,state,dispatch}:any, obj:any){
        //console.time('getData')
        commit('setLoading',true)

        // Prefer the server-side BFF: it decrypts the report token, scopes reads to
        // the token's company, and returns a ready-to-render view model — so the
        // client needs no shared-account login and never touches the DB directly.
        // Falls back to the legacy path below until the endpoint is deployed.
        if(obj.token){
            try{
                const res = await axios.post(
                    'https://us-central1-people2-admin.cloudfunctions.net/insightsHighPerformingManagers',
                    {token:obj.token, month:obj.month || ''},
                    {timeout:20000}
                )
                const d = res.data || {}
                commit('setAutosendgem', !!d.autosendgem)
                commit('setReplyRate', d.replyRate || {highPerformers:0,orgAverage:0,compare:0})
                commit('setDebi', d.debi || {highPerformers:0,orgAverage:0,compare:0})
                commit('sethighPerformingManagers', Array.isArray(d.highPerformingManagers) ? d.highPerformingManagers : [])
                commit('setLoading', false)
                return
            }catch(error){
                console.log('high-performing-managers BFF unavailable, using legacy path', error)
            }
        }

        const autosendgemQuery = await firebase.firestore().collection('powerups_schedule').where('company','==',obj.com_id).where('typeLibary','==','activemanagers').get();
        const autosendgem = autosendgemQuery.docs.length > 0 ? autosendgemQuery.docs[0].data().status :false;
        commit('setAutosendgem',autosendgem)

        const month = obj.month ? obj.month : format(addMonths(new Date(), -1), 'YYYY-MM')
        const replyRate = {
            highPerformers:0,
            orgAverage:0,
            compare:0
        }
        const debi = {
            highPerformers:0,
            orgAverage:0,
            compare:0
        }
        const promises1 = new Promise((resolve,reject)=>{
            getUserAll(obj.com_id).then((res)=>{
                //console.log('res===1',res)
                resolve(res)
            }).catch((error)=>{
                // ไม่ให้หน้าค้าง loading ถ้าดึง users ไม่ได้ — แสดงผลโดย count เป็น 0
                console.log('getUserAll failed:', error)
                resolve({})
            })
        })


        const promises=new Promise((resolve,reject)=>{
            firebase.firestore().collection('high_performing_managers').doc(`${obj.com_id}-${month}`).get().then((doc)=>{
                resolve(doc.data())
            })
        })


        await Promise.all([promises1,promises]).then((values)=>{
            let user:any = values[0]
            const data:any = values[1]
  


            if(data){
                replyRate.highPerformers = data.high_performing_managers_replyRate
                replyRate.orgAverage = data.avg_replyRate
                replyRate.compare = replyRate.highPerformers - replyRate.orgAverage
                debi.highPerformers = data.high_performing_managers_debi
                debi.orgAverage = data.avg_debi
                debi.compare = debi.highPerformers - debi.orgAverage
            }
                commit('setReplyRate',replyRate)
                commit('setDebi',debi)
            if(data&&data.high_performing_managers_list){
                //console.log('data.highPerformingManagers===',data.high_performing_managers_list)
                for(const item of data.high_performing_managers_list){
                    item.high_performing_managers = user[item.email.replace(/\./g, '||')]&&user[item.email.replace(/\./g, '||')].high_performing_managers?user[item.email.replace(/\./g, '||')].high_performing_managers:0
                }
                commit('sethighPerformingManagers',data.high_performing_managers_list)
            }else{
                commit('sethighPerformingManagers',[])
            } 
            
            //console.timeEnd('getData')
            commit('setLoading',false)

        })

    },
    




  },
  getters: {
    highPerformingManagers: (state:any) => {
      return state.highPerformingManagers
    },
    company: (state:any) => {
      return state.company
    },
    replyRate: (state:any) => {
      return state.replyRate
    },
    debi: (state:any) => {
      return state.debi
    },
    user: (state:any) => {
      return state.user
    },
    loading: (state:any) => {
      return state.loading
    },
    autosendgem: (state:any) => {
      return state.autosendgem
    }
  }
}